function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionCampaignRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.484 25.53l-4.03-4.044 5.392-14.439L24.96 20.208 10.484 25.53zm8.342 1.24l-3.176 1.168a.998.998 0 01-1.287-.6l-.349-.968 5.054-1.859.353.982a1.003 1.003 0 01-.595 1.277zM7.713 27.944c-.012.012-.049.05-.117.05s-.104-.038-.116-.05L4.048 24.5a.168.168 0 010-.234l1.174-1.178 3.664 3.677-1.173 1.18zm5.494-22.37a1.946 1.946 0 00-3.215.72L4.515 20.96l-1.882 1.888a2.18 2.18 0 000 3.072l3.433 3.444a2.15 2.15 0 001.53.637c.554 0 1.108-.212 1.531-.637l1.88-1.888 1.131-.415.344.955a2.97 2.97 0 001.555 1.702 2.977 2.977 0 002.302.098l3.177-1.168a3.009 3.009 0 001.787-3.832l-.357-.994 4.764-1.752c1.344-.486 1.728-2.212.717-3.227L13.207 5.574zM18.005 6.998h2V2h-2v4.998zM25.002 13.995H30v-2h-4.998v2zM27.708 5.705l-1.414-1.413-3.998 3.998 1.414 1.414 3.998-3.999z",
    fill: props.color
  }));
}

export default SvgIconPromotionCampaignRexOutline;